<template lang="html">
    <div id="account">
        <header>
            Validation Code
            <router-link :to="{ name: 'Account' }"
                ><chevron-left-icon class="icon"></chevron-left-icon
            ></router-link>
        </header>

        <form class="form privacy">
            <div class="formGroup">
                <p class="help" style="margin-bottom: 20px">
                    This is your personal validation code used to invite Players to the system to
                    create the link between their account and yours.
                </p>

                <p class="help">
                    Please distribute this code to new Players and ensure they enter it when signing
                    up to Lesson Pro.
                </p>

                <p class="help divider" style="font-size: 18px">{{ user.referral_code }}</p>
            </div>
        </form>
    </div>
</template>

<script>
import { ChevronLeftIcon } from "vue-feather-icons";
export default {
    name: "privacy",
    components: { ChevronLeftIcon },
    data() {
        return {};
    },
    mounted() {},
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.divider {
    margin-top: 20px;
    border-top: 1px solid #4b4e4c;
    padding-top: 20px;
}
</style>
